import { REQUEST_TRACKER_TRANSACTIONS, RECEIVED_TRACKER_TRANSACTIONS_SUCCESS, RECEIVED_TRACKER_TRANSACTIONS_ERROR } from '../commonActionTypes';

const initialState = {
  isLoading: false,
  error: false,
  transactions: [],
  configs: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case REQUEST_TRACKER_TRANSACTIONS:
      return { ...initialState, isLoading: true };
    case RECEIVED_TRACKER_TRANSACTIONS_SUCCESS:
      return {
        ...state, isLoading: false, transactions: action.payload.responseData, configs: action.payload.configs,
      };
    case RECEIVED_TRACKER_TRANSACTIONS_ERROR:
      return { ...initialState, isLoading: false, error: true };
    default:
      return state;
  }
}
